import { cn } from "@babybjorn/ui";
import type { FC, ReactNode } from "react";
import Icon from "../../../Icon";
import Link from "../../../Link";
import Tag from "../../../Tag";
import * as s from "./ListItem.module.scss";

export type ListItemProps = {
	variant?: string;
	image?: ReactNode;
	title?: string;
	description?: string;
	href?: string;
	tag?: string;
	target?: string;
	productTab?: boolean;
	searchIcon?: boolean;
	price?: string;
};

const ListItem: FC<ListItemProps> = ({
	variant = "standard",
	image,
	title,
	description,
	href,
	tag,
	target = "_self",
	productTab = false,
	searchIcon = false,
	price,
}) => {
	return (
		<li className={s.container}>
			{variant === "standard" && (
				<Link href={href} target="_self">
					<div className={cn(s[variant])}>
						{image && <div className={s.image}>{image}</div>}
						{(title || description) && (
							<div className={s.wrapper}>
								{title && (
									<div className={s.heading}>
										<h5 className={s.title}>{title}</h5>
										{tag && <Tag label={tag} className={s.tag} alwaysSmall />}
									</div>
								)}
								{description && (
									<p
										className={cn(s.description, {
											[s.productTab]: productTab,
										})}
									>
										{description}
									</p>
								)}
							</div>
						)}
					</div>
				</Link>
			)}
			{variant === "block" && (
				<Link href={href} target={target}>
					<div className={cn(s[variant])}>
						{(title || description) && (
							<div className={s.wrapper}>
								{title && (
									<div className={s.heading}>
										<h5>{title}</h5>
									</div>
								)}
								{description && (
									<p
										className={cn(s.description, {
											[s.productTab]: productTab,
										})}
									>
										{description}
									</p>
								)}
							</div>
						)}
						{image && <div className={s.image}>{image}</div>}
					</div>
				</Link>
			)}
			{variant === "list" && (
				<Link href={href} target={target}>
					<div className={cn(s[variant])}>
						{title && (
							<div className={cn(s.wrapper, s.list)}>
								{searchIcon && (
									<Icon icon="search" className={s.icon} width={20} />
								)}
								{title && (
									<p
										className={cn(s.title, {
											[s.productTab]: productTab,
										})}
									>
										{title}
									</p>
								)}
							</div>
						)}
					</div>{" "}
				</Link>
			)}
			{variant === "pages" && (
				<Link href={href} target="_self">
					<div className={cn(s[variant])}>
						{image && <div className={s.image}>{image}</div>}
						{(title || description) && (
							<div className={s.wrapper}>
								{title && <h5 className={s.title}>{title}</h5>}
								{description && (
									<p
										className={cn(s.description, {
											[s.productTab]: productTab,
										})}
									>
										{description}
									</p>
								)}
							</div>
						)}
					</div>
				</Link>
			)}
			{variant === "product" && (
				<Link href={href} target="_self">
					<div className={cn(s[variant])}>
						{image && <div className={s.image}>{image}</div>}
						<div className={s.wrapper}>
							{(title || description) && (
								<div>
									{title && <h5 className={s.title}>{title}</h5>}
									{description && (
										<p className={s.description}>{description}</p>
									)}
								</div>
							)}
							{price && <p className={s.price}>{price}</p>}
						</div>
					</div>
				</Link>
			)}
		</li>
	);
};

export default ListItem;
